// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconDashboard1 = createRemixIcon('IconDashboard1', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M.75.75h22.5v22.5H.75zm2.5 13.5v-4.5l6.5-6.5h4.5l6.5 6.5v4.5l-6.5 6.5h-4.5z\" clip-rule=\"evenodd\"/>");
